import React from "react";
import { connect } from "react-redux";
import { Table, Button, Tab } from "semantic-ui-react";
import _ from "lodash";
import SexOffenderNimbus from "./SexOffenderNimbus";
import ResultHeader from "./ResultHeader";
import {
  getReportPriceDetails,
  getPriceMessage,
} from "../common/ReportPriceDetails";
import "../../assets/styles/sub-table.css";
import { addReportIdToAdditionalData } from "../common/Utils";
import { getMenuItem } from "../common/PageHelper";
import { getDobDate } from "../common/DisplayDate";
import Name from "./Name";

class CriminalMultiSectionNimbusResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    const selectedRows = [];
    let reportPriceDetails = {};
    let reportPriceMessage = "";
    let calculatedReportPrice = 0;
    let recLen = 0;
    // if(props.additionalData.errorMessage) {
    //   results.push(<Table.Row key="multi_crim_rec_err"><Table.Cell>{props.additionalData.errorMessage}</Table.Cell></Table.Row>)
    // }
    // else 
    if (!props.additionalData.errorMessage &&
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      const crimResults = _.get(
        props.searchResultData,
        "criminals.response[0].output[0].criminals[0].criminal"
      );
      reportPriceDetails = getReportPriceDetails(
        props.additionalData,
        props.reports
      );
      reportPriceMessage = getPriceMessage(reportPriceDetails);
      calculatedReportPrice = reportPriceDetails.basePrice;
      if (crimResults)
        _.forEach(crimResults, (crimRes, criIndex) => {
          const dob = getDobDate(_.get(crimRes, "suspect[0].DOB[0]"), {
            userAccount: this.props.userAccount,
          });
          const name = (<Name
            node={_.get(crimRes, "suspect[0].name[0]")}
            handleNewSearchClick={this.props.handleNewSearchClick}
          />);

          selectedRows[`chk_sel_${crimRes.$.internalID}`] = false;
          const colorClass = criIndex % 2 === 0 ? "odd-row" : "even-row";
          results.push(
            <Table.Row key={`Crim_Row_${criIndex}`} className={colorClass}>
              <Table.Cell
                className={"icon-align-middle text-center border-right"}
              >
                <input
                  type="checkbox"
                  id={`chk_sel_${crimRes.$.internalID}`}
                  onChange={this.handleReportSelection}
                />
              </Table.Cell>
              <Table.Cell>
                <SexOffenderNimbus
                  key={`Crim_Table_${criIndex}`}
                  node={crimRes}
                  dob={dob}
                  name={name}
                  index={criIndex}
                  {...props}
                />
              </Table.Cell>
            </Table.Row>
          );
          recLen += 1;
        });
    }

    this.state = {
      selectedRows,
      results,
      ignoreCheckAll: false,
      recLen,
      reportPriceDetails,
      reportPriceMessage,
      calculatedReportPrice,
    };
  };

  handleReportSelection = (e) => {
    const selectedRows = this.state.selectedRows;
    selectedRows[e.target.id] = e.target.checked;
    const sel = _.countBy(Object.keys(selectedRows), (k) => selectedRows[k]);
    const checkAll = document.getElementById("Chk_All_Result");
    if (
      !this.state.ignoreCheckAll &&
      ((checkAll.checked &&
        (sel.true === undefined || sel.false !== undefined)) ||
        (!checkAll.checked && sel.false === undefined))
    ) {
      this.state.ignoreCheckAll = true;
      document.getElementById("Chk_All_Result").click();
    }
    this.setState({ selectedRows });
    this.updateCalculatedReportPrice(selectedRows);
  };

  handleResultSelectAll = (e) => {
    if (!this.state.ignoreCheckAll) {
      this.state.ignoreCheckAll = true;
      _.forEach(Object.keys(this.state.selectedRows), (key) => {
        if (e.target.checked !== this.state.selectedRows[key]) {
          document.getElementById(key).click();
        }
      });
      this.state.ignoreCheckAll = false;
    } else {
      this.state.ignoreCheckAll = false;
    }
  };

  updateCalculatedReportPrice = (selectedRows) => {
    const reportPriceDetails = this.state.reportPriceDetails;
    if (reportPriceDetails.baseReportCount > 0) {
      const sel = _.countBy(Object.keys(selectedRows), (k) => selectedRows[k]);
      if (sel && sel.true) {
        const additionalReports = sel.true - reportPriceDetails.baseReportCount;
        const calculatedReportPrice =
          reportPriceDetails.basePrice +
          (additionalReports > 0
            ? additionalReports * reportPriceDetails.addPrice
            : 0);
        this.setState({ calculatedReportPrice });
      }
    }
  };

  showReport = () => {
    const rows = [];
    _.forEach(Object.keys(this.state.selectedRows), (key) => {
      if (this.state.selectedRows[key] === true) {
        rows.push(parseInt(key.replace("chk_sel_", ""), 10));
      }
    });
    const orderedRows = _.orderBy(rows, (v) => v, "asc");
    const additionalData = {
      bttype: this.props.userAccount.btType,
      optReportType: "inmate",
    };
    addReportIdToAdditionalData(this.props, additionalData);
    this.props.showReport(
      undefined,
      "criminalReport",
      _.join(orderedRows, "|"),
      additionalData
    );
  };

  render() {
    const tabs = [];
    const acctType = _.get(
      this.props.searchResultData,
      `${Object.keys(this.props.searchResultData)[0]}.log[0].actType[0]`,
      ""
    );
    const sel = _.countBy(
      Object.keys(this.state.selectedRows),
      (k) => this.state.selectedRows[k]
    );
    const showNarrowSearchMessage =
      this.state.recLen > 25 &&
      (acctType.indexOf("Person") !== -1 ||
        acctType.indexOf("People") !== -1) &&
      acctType.indexOf("Enhanced") === -1;
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${this.state.recLen} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          <ResultHeader
            showNarrowSearchMessage={showNarrowSearchMessage}
            {...this.props}
          />
          {this.state.recLen > 0 && (
            <Table key={"pricing"}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={2} className={"icon-align-middle"}>
                    <input
                      type="checkbox"
                      id={"Chk_All_Result"}
                      onChange={this.handleResultSelectAll}
                    />{" "}
                    {"\t"} Select All
                  </Table.Cell>
                  <Table.Cell className={"page-sub-title icon-align-middle"}>
                    {this.state.reportPriceMessage}
                  </Table.Cell>
                  <Table.Cell>
                    {sel.true !== undefined &&
                      (this.state.calculatedReportPrice > 0 ? (
                        <Button
                          className={"float-right"}
                          onClick={this.showReport}
                        >{`Get ${sel.true
                          } report(s) for $${this.state.calculatedReportPrice.toFixed(
                            2
                          )}`}</Button>
                      ) : (
                        <Button
                          className={"float-right"}
                          onClick={this.showReport}
                        >{`Get ${sel.true} report(s)`}</Button>
                      ))}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          )}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    reports: state.uiData.Reports,
    userAccount: state.userAccount,
  };
}
export default connect(mapStateToProps, null)(CriminalMultiSectionNimbusResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/CriminalMultiSectionNimbusResult.js